import React from "react";
import { classNames } from '../../helpers/common.helpers';
import { PortableText } from "@portabletext/react";
import SystemTabs from '../SystemTabs'

export default function SystemAccordion({sections}) {    
  
    const [open, setOpen] = React.useState(0);
    
    const handleOpen = (value) => setOpen(open === value ? 99 : value);

    return (
        <>
          {sections && sections.map((section, index) => (
            <div key={index}>
              <button
                type="button"
                onClick={() => handleOpen(index)}
                className={classNames(
                  'w-full text-left accordion_title_border_tp font-bold py-4',
                  (index % 1 == 0) ? 'bg_1' : '',
                  (index % 2 == 0) ? 'bg_2' : '',
                  (index % 3 == 0) ? 'bg_3' : '',
                  (index % 4 == 0) ? 'bg_4' : '',
                  (index % 4 == 0) ? 'bg_5' : '',
                  (index % 4 == 0) ? 'bg_6' : '',
                  (open === index) ? 'accordion_title_border' : 'accordion_title_border_tp'
                )}
              >
                <h4 className="mx-10 my-2 text-primary">{section.title}</h4>
              </button>

              {open === index ? (
                <div className="text-primary">
                  <div className="m-10">
                    <h2 className="text-3xl lg:text-5xl text-left mt-16 mb-10">
                      {section.heading}
                    </h2>
                    <div className="contentBlock text-left text-lg">
                      <PortableText value={section.body} />
                    </div>
                    <div className="my-10">
                      <SystemTabs tabs={section.tabs} />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ))}
        </>
    );
  }